// src/components/shared/ExtractButton.jsx
import React from 'react'

function ExtractButton ({ onExtract, disabled, loading, className = '' }) {
  return (
    <button
      type='button'
      className={`btn btn-primary${
        loading ? ' btn-primary-laedt' : ''
      } ${className}`.trim()}
      onClick={onExtract}
      disabled={disabled || loading}
    >
      {loading ? 'Extrahiere…' : 'Extrahieren'}
    </button>
  )
}

export default ExtractButton
